import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-pos-invoice-pay-with-money-equipment',
  templateUrl: './pos-invoice-pay-with-money-equipment.component.html',
  styleUrls: ['./pos-invoice-pay-with-money-equipment.component.scss']
})
export class PosInvoicePayWithMoneyEquipmentComponent implements OnInit {

  // invoice = {
  //   invoiceNumber: '',
  //   invoiceAmount: 0,
  //   invoiceBalance: 0,
  //   salesOrderNumber: '',
  //   depositBalance: 0,
  //   customer: '',
  //   accountBalance: 0
  // };

  invoice = null;

  storeId: number;
  containerId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;

  constructor(
    public dialogRef: MatDialogRef<PosInvoicePayWithMoneyEquipmentComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_pos_payment_invoice_from_money_equipment_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.invoice = response.data.invoiceDetails;
        } else {
          this.dialogRef.close(false);
        }
      });
  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  save() {
    const payload = {
      salesOrderNumber: this.invoice.salesOrderNumber,
      invoiceNumber: this.invoice.invoiceNumber,
      storeId: this.storeId,
      containerId: this.containerId,
      equipmentTypeCode: this.equipmentTypeCode,
      amountPaid: this.formValue.amountTendered,
      paymentData: this.formValue
    };

    const dialogData: OiGroupDialogData = {
      title: 'Authorizing TFG Credit Card',
      function: 'portal_oi_group_payment_invoice_payment_from_money_equipment',
      postBody: payload
    };

    if (this.formValue.amountTendered > this.invoice.invoiceBalance) {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Overpaying an invoice?',
          text: `Are you sure you want to overpay this invoice? ${(this.formValue.amountTendered - this.invoice.invoiceBalance).toFixed(2)} will be added to the customer account (This is not allowed for TFG Credit or a SYSPRO cash customer).`,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.confirmButtonClicked === true) {
          const ref = this.dialog.open(OiGroupProcessDialogComponent, {
            data: dialogData,
            width: '450px'
          });

          ref.afterClosed().subscribe(oiResult => {
            if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
              this.dialogRef.close(true);
            }
          });
        }
      });
    } else {
      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
          this.dialogRef.close(true);
        }
      });
    }
  }

}
